<template>
  <div class="listContent" ref="listRef">
    <a-form :form="form" class="headForm">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="指标名称">
            <a-input
              @pressEnter="
                getList({ pageSize: pagination.pageSize, current: 1 })
              "
              v-decorator="['name']"
              placeholder="请输入指标名称"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item label="指标类型">
            <a-cascader
              v-decorator="['typeArr']"
              :options="typeList"
              :load-data="loadData"
              placeholder="请选择"
              change-on-select
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" class="submitBtnBox">
          <a-button
            type="primary"
            class="btnMar"
            @click="getList({ pageSize: pagination.pageSize, current: 1 })"
          >
            查询
          </a-button>
          <a-button class="btnMar2" @click="resetFields"> 清空 </a-button>
        </a-col>
      </a-row>
    </a-form>

    <div class="editBox" style="height: 52px">
      <!-- <a-button style="margin-right: 20px;" type="danger" ghost @click="clearAll">恢复基础工厂数据</a-button> -->
      <!-- 曾静修改---------------- -->
      <p style="display: inline-block;margin-right: 20px;">参考原料：{{quoteMaterial.name ? quoteMaterial.name + '-' + quoteMaterial.code : '未设置参考原料'}}</p>
      <!-- 新增一键清理按钮 -->
      <a-button style="margin-right: 0;" type="danger" ghost @click="clearAll">恢复基础工厂数据</a-button>

      <div style="display: flex; float: right">
        <!-- <a-button @click="resetData">
        重置
      </a-button> -->
        <!-- <a-button type="primary" @click="showAddFunc">
        新增
      </a-button>
      <a-button @click="deleteData" type="danger" ghost>
        移出
      </a-button> -->

        <!-- @change="getCalculationId" -->
        <!-- <div style="display: flex;justify-content: space-between;"> -->
        
        <!-- <a-button style="margin-right: 20px;" type="danger" ghost @click="clearAll">恢复基础工厂数据</a-button> -->
        <a-button-group>
          <a-select
            :disabled="!isFucCal"
            style="width: 200px"
            placeholder="选择方程"
            class="selectBtn"
            v-model="calculationId"
          >
            <a-select-option
              v-for="lo in equationList"
              :key="lo.id"
              :value="lo.id"
            >
              {{ lo.name }}
            </a-select-option>
          </a-select>

          <a-tooltip placement="top">
            <template slot="title">
               <span v-if="!isFucCal">该原料不能引用方程计算</span>
            </template>
            <a-button
              type="primary"
              :disabled="!isFucCal"
              @click="showCalculationFunc"
              >计算</a-button>
          </a-tooltip>
        </a-button-group>
        <!-- <a-button style="margin-right: 0;" type="danger" ghost @click="clearAll">恢复基础工厂数据</a-button> -->
      </div>
    </div>
    <resize-table
      :scroll="{ y, x: 1000 }"
      bordered
      :columns="columns"
      :data-source="list"
      class="tableBox textLeft"
      :pagination="false"
    >
      <a-tooltip slot="name" slot-scope="text,record">
        <template slot="title">
          {{overseasFlag == '1' ? (record.aliasName || text) : text}}
        </template>
        <span class="nameStyle">{{overseasFlag == '1' ? (record.aliasName || text) : text}}</span>
      </a-tooltip>
      <span slot="customTitle"
        ><a-icon
          @click="fixedCol"
          type="pushpin"
          :theme="filled ? 'filled' : 'outlined'"
        />
        指标名称</span
      >
      <template
        v-for="el in ['nutritionAnalysisVal', 'baseNutritionVal']"
        :slot="el"
        slot-scope="text"
      >
        <template v-if="text || text === 0">
          {{ Number(text).toFixed(precision[el] || 4) }}
        </template>
      </template>
      <template slot="nutritionValue" slot-scope="text, record">
        <template v-if="record.isAutoCal == 1">
          {{text || text === 0 ? text.toFixed(precision["nutritionValue"] || 3) : ''}}
        </template>
        <template v-else>
          <cell-editor
            :len="4"
            :precision="4"
            :item="record"
            key="nutritionValue"
            name="nutritionValue"
            :min="-9999999999"
            :max="9999999999"
            :text="text"
            @blur="(target) => itemUpdate(target, 'nutritionValue')"
            :actions="update"
            :background="true"
            class="setEditor"
          />
        </template>
        
      </template>
      <template slot="name6" slot-scope="text, record, index">
        <template>
          <!-- <a style="marginRight:10px" @click="editRow(record,'edit')">编辑</a> -->
          <a @click="resetRecord(text, record, index)">重置</a>
        </template>
        <!-- <div v-else>
          <a style="marginRight:10px" @click="saveList(record,'row')">保存</a>
          <a @click="editRow(record,'cancel',index)">取消</a>
        </div> -->
      </template>
    </resize-table>
    <!-- 查看计算结果 -->
    <a-modal
      title="查看计算结果"
      :visible="showCalculation"
      :confirm-loading="confirmLoading"
      @ok="calculationSubmit"
      @cancel="showCalculationFunc"
      cancelText="取消"
      okText="应用"
      :maskClosable="false"
      width="1100px"
      destroyOnClose
    >
      <a-space slot="footer">
        <a-button @click="showCalculationFunc">取消</a-button>
        <a-button type="primary" @click="calculationSubmit" :loading="confirmLoading">应用</a-button>
      </a-space>
      <ViewCalculationResults
        ref="calculation"
        :typeList="typeList"
        :calculationList="calculationList"
        @getTypeList="refreshTypeList"
      />
    </a-modal>
  </div>
</template>
<script>
import ViewCalculationResults from "./ModalConponents/ViewCalculationResults.vue";
import { getRequest } from "@/components/Common/Utils/Utils";
import CellEditor from "./ModalConponents/CellEditor.vue";
export default {
  components: {
    ViewCalculationResults,CellEditor
  },
  data() {
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      isFucCal: this.$route.query.isFucCal == 1 ? true : false, //能否开启方程计算
      precision: this.$store.state.precision,
      inputVal: "",
      applicationList: [],
      selectRows: [],
      loading: false,
      recordObj: {},
      y: 500,
      mid: false,
      saveAllFlag: true,
      editFlag: true,
      calculationFlag: true,
      calculationId: "",
      calculationList: [],
      equationList: [],
      form: this.$form.createForm(this, { name: "rawMaterialList" }),
      showCalculation: false,
      typeList: [],
      selectList: [],
      oldList: [],
      oldList2: [],
      confirmLoading: false,
      showAdd: false, // 是否显示新增
      showEdit: false, // 是否显示编辑
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 },
      },
      pagination: {
        total: 0,
        pageSize: 10000,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.getList({ current, pageSize });
        }, //选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.current = 1;
          this.pagination.pageSize = pageSize;
          this.getList({ current: 1, pageSize });
        }, //每页多少条
      },
      list: [],
      otherList: [],
      columnsAll: [
        {
          // title: "指标名称",
          width: 160,
          dataIndex: "name",
          slots: { title: 'customTitle' },
          scopedSlots: { customRender: "name" },
        },
        {
          title: "指标全称",
          dataIndex: "fullName",
        },
        {
          title: "类型",
          dataIndex: "typeName",
        },
        {
          title: "数值",
          dataIndex: "nutritionValue",
          scopedSlots: { customRender: "nutritionValue" },
          sorter: (a, b) => a.nutritionValue - b.nutritionValue,
        },
        {
          title: "营养分析",
          dataIndex: "nutritionAnalysisVal",
          scopedSlots: { customRender: "nutritionAnalysisVal" },
          width: 120,
          ellipsis: true,
          sorter: (a, b) => a.nutritionAnalysisVal - b.nutritionAnalysisVal,
        },
        {
          title: "基础工厂",
          dataIndex: "baseNutritionVal",
          scopedSlots: { customRender: "baseNutritionVal" },
          width: 120,
          ellipsis: true,
          sorter: (a, b) => a.baseNutritionVal - b.baseNutritionVal,
        },
        {
          title: "单位",
          dataIndex: "unit",
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
        },
        // {
        //   title: '操作',
        //   dataIndex: 'name6',
        //   scopedSlots: { customRender: 'name6' },
        // }
      ],
      quoteMaterial: {},
      filled: false,
      // rowSelection:{
      //   onChange: (selectedRowKeys) => {
      //     this.selectList = selectedRowKeys
      //   },
      // }
    };
  },
  mounted() {
    this.getList();
    this.getTypeList();
    this.getCalculationList();
    this.y = this.$refs.listRef.offsetHeight - 10 - 80 - 52 - 40 - 18;
    this.getQuoteMaterial(getRequest("rawId"));
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectRows) => {
          this.selectList = selectedRowKeys;
          this.selectRows = selectRows;
        },
        selectedRowKeys: this.selectList,
      };
    },
    columns() {
      let columns = [...this.columnsAll];
      if (this.filled) {
        columns[0].fixed = "left";
      } else {
        delete columns[0].fixed;
      }
      return columns;
    },
  },

  methods: {
    async itemUpdate(item, feild) {
      let val = item[feild];
      let record = this.list.filter((el) => el.code === item.code)[0];
      record[feild] = val;
      // await this.saveList(item,'row')
    },
    async update(arg) {
      arg.aliasName = !arg.aliasName ? null : arg.aliasName
      // await this.saveList(arg,'row')
      arg.customId = getRequest('customId')
      let res = await this.$post('/nhf-custom/custfactorystaffnutritionraw/singleAutoUpdateStaffCustNutritionRawList',{custFactoryStaffNutritionRawList:[arg]})
      let { success ,data} = res;
      this.editFlag = true;
      if (success) {
        this.calculationFlag = true;
        this.oldList2 = JSON.parse(JSON.stringify([...this.oldList]));
          for(let item in data){
            let obj = this.list.find(el => el.code === item) || {}
            let newObj = data[item]
            if(obj && obj.code){
              if(newObj.nutritionValue === null){
                obj.nutritionAnalysisVal = obj.baseNutritionVal
                obj.nutritionValue = newObj.nutritionValue
                obj.updateTime = newObj.updateTime
              }else{
                obj.nutritionAnalysisVal = newObj.nutritionValue
                obj.nutritionValue = newObj.nutritionValue
                obj.updateTime = newObj.updateTime
              }
              obj.id = newObj.id
            }
          }
        }

      return {};
    },
    fixedCol(e) {
      this.filled = !this.filled;
      e = e || window.event;
      if (e.stopPropagation) {
        //W3C阻止冒泡方法
        e.stopPropagation();
      } else {
        e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    getQuoteMaterial(rawId) {
      this.$http
        .get("/nhf-core-data/rawreference/getReferenceRawDetail", {
          params: { rawId },
        })
        .then((res) => {
          let { success, data } = res;
          if (success) {
            this.quoteMaterial = data || {};
          }
        });
    },
    renderColumns(columns) {
      return columns.map((item) => {
        if (item.dataIndex === "nutritionValue") {
          return {
            ...item,
            customCell: (record) => {
              return {
                // on: {
                //   click: () => {
                //     if (record.isAutoCal == 1) {
                //       this.recordObj = {}
                //     }else{
                //       this.inputVal = record[item.dataIndex];
                //       this.editRow(record, "edit");
                //     }
                //   },
                // },
                style: {
                  background: record.isAutoCal == 1 ? "" : "#e6f7ff",
                  // background: "#e6f7ff",
                },
              };
            },
          };
        } else {
          return item;
        }
      });
    },
    conversion(val, record) {
      let DM = this.oldList.filter((el) => el.name === "DM")[0] || {};
      let Moisture =
        this.oldList.filter((el) => el.name === "Moisture")[0] || {};
      let currentObj =
        this.oldList.filter((el) => el.name === record.name)[0] || {};
      if (record.name === "DM") {
        let converObj =
          this.oldList.filter((el) => el.name === "Moisture")[0] || {};
        let converObj2 =
          this.list.filter((el) => el.name === "Moisture")[0] || {};
        this.mid = true;
        if (!record.nutritionValue && record.nutritionValue !== 0) {
          DM.nutritionValue = "";
          Moisture.nutritionValue = "";
          converObj.nutritionValue = "";
          converObj2.nutritionValue = "";
        } else {
          DM.nutritionValue = val;
          Moisture.nutritionValue = 100 - val;
          converObj.nutritionValue = 100 - val;
          converObj2.nutritionValue = 100 - val;
        }
      } else if (record.name === "Moisture") {
        // if(record.nutritionValue === Moisture.nutritionValue) return
        let converObj = this.oldList.filter((el) => el.name === "DM")[0] || {};
        let converObj2 = this.list.filter((el) => el.name === "DM")[0] || {};
        this.mid = true;
        if (!record.nutritionValue && record.nutritionValue !== 0) {
          Moisture.nutritionValue = "";
          DM.nutritionValue = "";
          converObj.nutritionValue = "";
          converObj2.nutritionValue = "";
        } else {
          Moisture.nutritionValue = val;
          DM.nutritionValue = 100 - val;
          converObj.nutritionValue = 100 - val;
          converObj2.nutritionValue = 100 - val;
        }
      }
      currentObj.nutritionValue = record.nutritionValue;
    },
    saveList(record, type) {
      // if (this.loading) return;
      if (this.$refs.getFocus) {
        this.$refs.getFocus.blur();
      }
      let custFactoryStaffNutritionRawList = [];
      let flag = false;
      this.loading = true;
      if (type === "row") {
        if (record) record.edit = false;
        if(record.nutritionValue != this.inputVal){
          record.nutritionValue = this.inputVal;
          let {fullName,...newRecord} = record || {}
          this.fullName = fullName
          newRecord.customId = getRequest('customId')
          custFactoryStaffNutritionRawList = [newRecord]
        }
      } else if (type === "application") {
        custFactoryStaffNutritionRawList = this.applicationList;
      } else {
        this.oldList &&
          this.oldList.forEach((el) => {
            let newObj = JSON.parse(JSON.stringify(el));
            let { fullName, ...newRecord } = newObj;
            this.fullName = fullName
            newRecord.customId = getRequest('customId')
            custFactoryStaffNutritionRawList.push(newRecord);
          });
      }
      this.recordObj = {};
      if (flag) {
        this.loading = false;
        return;
      }
      let _this = null;
      _this = this["$post"];
      custFactoryStaffNutritionRawList = [...custFactoryStaffNutritionRawList,...this.otherList]
      if (custFactoryStaffNutritionRawList.length === 0) {
        this.calculationFlag = true;
        this.oldList2 = JSON.parse(JSON.stringify([...this.oldList]));
        this.loading = false;
        return;
      }
      let url = "/nhf-custom/custfactorystaffnutritionraw/batchUpdateStaffNutritionRawList";
      if (type === "row" && custFactoryStaffNutritionRawList.length === 1) url = '/nhf-custom/custfactorystaffnutritionraw/singleAutoUpdateStaffCustNutritionRawList'
      _this(url, { custFactoryStaffNutritionRawList })
        .then((res) => {
          let { success ,data} = res;
          this.editFlag = true;
          if (success) {
            this.calculationFlag = true;
            this.oldList2 = JSON.parse(JSON.stringify([...this.oldList]));
            if (type === "row") {
              for(let item in data){
                let obj = this.list.find(el => el.code === item) || {}
                let newObj = data[item]
                if(obj && obj.code){
                  if(newObj.nutritionValue === null){
                    obj.nutritionAnalysisVal = obj.baseNutritionVal
                    obj.nutritionValue = newObj.nutritionValue
                    obj.updateTime = newObj.updateTime
                  }else{
                    obj.nutritionAnalysisVal = newObj.nutritionValue
                    obj.nutritionValue = newObj.nutritionValue
                    obj.updateTime = newObj.updateTime
                  }
                  obj.id = newObj.id
                }
              }
            } else if (type === "application") {
              this.getList(this.pagination, "refresh");
            }
          } 
          this.recordObj = {};
        })
        .finally(() => {
          this.loading = false;
          this.recordObj = {};
          this.confirmLoading = false
          this.showCalculation = false;
        });
    },
    getCalculationList() {
      this.$http.get("/nhf-fine/equation/list").then((res) => {
        let { success, data } = res;
        if (success) {
          this.equationList = data || [];
          this.calculationId = data[0] && data[0].id ? data[0].id : "";
        }
      });
    },
    calculationSubmit() {
      this.confirmLoading = true
      // this.showCalculation = false;
      let list = [];
      let oldList = JSON.parse(JSON.stringify(this.$refs.calculation.list))
      oldList.forEach((el) => {
        if (el.nutritionValue != el.culationValue) {
          el.nutritionValue = el.culationValue;
          el.isBelongRaw = !el.id ? "0" : "1";
          el.staffId = window.localStorage.getItem("staffId");
          el.factoryId = window.localStorage.getItem("factoryId");
          el.customId = getRequest('customId')
          list.push(el);
        }
      });
      this.applicationList = [...list] || [];
      this.saveList(false, "application");
    },
    showCalculationFunc() {
      if (!this.showCalculation) {
        if (!this.calculationId) {
          this.$message.warning("请选择方程式");
        } else {
          this.calculationList = [];
          this.$http
            .post(
              "/nhf-custom/custfactorystaffnutritionraw/custRawEquationCalculateBackGround",
              {
                customId: getRequest('customId'),
                equationId: this.calculationId,
                rawId: getRequest("rawId"),
                factoryId: window.localStorage.getItem("factoryId"),
              }
            )
            .then((res) => {
              let { success, data, msg } = res;
              if (success) {
                data &&
                  data.map((el) => {
                    el.difference = el.culationValue - el.nutritionValue;
                    el.edit = false;
                    return el;
                  });
                let list = data.filter(
                  (e) => e.typeId !== "1386613070176682199"
                );
                let otherList =  data.filter(
                  (e) => e.typeId === "1386613070176682199"
                );
                otherList && otherList.map(el => {
                  el.nutritionValue = el.culationValue
                  return el
                })
                this.otherList = otherList || []
                this.calculationList = list || [];
                this.showCalculation = !this.showCalculation;
              } else {
                console.log(msg);
                this.$message.warning("指标数值异常，请修改后再计算。");
              }
            });
        }
      } else {
        setTimeout(() => {
          this.showCalculation = !this.showCalculation;
        }, 0);
      }
    },
    editList(flag) {
      this.editFlag = flag;
      this.list &&
        this.list.map((e) => {
          e.edit = !this.editFlag;
          return e;
        });
      if (flag) {
        this.list &&
          this.list.map((el) => {
            let row = this.oldList2.filter((e) => el.id === e.id)[0] || {};
            el.nutritionValue = row.nutritionValue;
          });
      }
    },
    resetFields() {
      this.form.resetFields();
    },
    refreshTypeList(data) {
      this.getTypeList(data.id, data.targetOption);
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        this.getTypeList(targetOption.id, targetOption) || [];
      }, 0);
    },
    getTypeList(parentId = 0, record) {
      this.$http.get(`/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeId?category=nutritiontarget&parentId=${parentId}`)
        .then((res) => {
          let { success, data = [] } = res;
          if (success) {
            data &&
              data.map((el) => {
                el.value = el.id;
                el.label = el.name;
                el.isLeaf = !el.hasChildren;
                // el.isLeaf = false
                return el;
              });
            if (record) {
              if (data.length) {
                record.children = data;
              } else {
                record.isLeaf = true;
              }
              this.typeList = [...this.typeList];
            } else {
              this.typeList = data;
            }
          } else {
            this.typeList = [];
          }
        });
    },
    async getList(pagination) {
      this.applicationList = [];
      this.selectList = [];
      this.mid = {};
      let { current = 1, pageSize = 10 } = pagination || this.pagination;
      let id = getRequest("id");
      this.form.validateFields((err, data) => {
        let { typeArr = [], ...newdata } = data;
        let params = {
          ...newdata,
          current,
          id,
          size: pageSize,
          typeId: typeArr.length ? typeArr[typeArr.length - 1] : undefined,
        };
        this.$http.get('/nhf-custom/custfactorystaffnutritionraw/selectCustFactoryStaffNutritionRawInfoWithoutSpecialTypePage',{params}).then(res => {
          let { success, data } = res;
          if (success) {
            this.list = [];
            let { records, current = 1, total = 0 } = data;
            this.pagination.current = current;
            this.pagination.total = total;
            records &&
              records.map((el) => {
                el.edit = false;
                el.updateTime = el.updateTime ? el.updateTime : ''
                return el
              });
            this.list = [...records] || [];
            this.oldList = JSON.parse(JSON.stringify([...records]));
            this.oldList2 = JSON.parse(JSON.stringify([...records]));
          } else {
            this.$message.error("查询失败");
          }
        })



        // _this('/nhf-app/factorystaffnutritionraw/selectFactoryStaffNutritionRawInfoWithoutSpecialTypePage',(method === 'row' || type === 'refresh')?params:{params}).then(res => {

        // let _this = null;
        // _this = this["$http"]["get"];
        // _this(
        //   "/nhf-app/factorystaffnutritionraw/selectFactoryStaffNutritionRawInfoWithoutSpecialTypePage",
        //   { params }
        // ).then((res) => {
        //   let { success, data } = res;
        //   if (success) {
        //     this.list = [];
        //     let { records, current = 1, total = 0 } = data;
        //     this.pagination.current = current;
        //     this.pagination.total = total;
        //     records &&
        //       records.map((el) => {
        //         el.edit = false;
        //       });
        //     this.list = [...records] || [];
        //     this.oldList = JSON.parse(JSON.stringify([...records]));
        //     this.oldList2 = JSON.parse(JSON.stringify([...records]));
        //   } else {
        //     this.$message.error("查询失败");
        //   }
        // });
        // }
      });
    },
    editRow(record, val) {
      // 编辑行
      if (val === "save" || val === "cancel") {
        if (val === "cancel") {
          this.list &&
            this.list.map((el) => {
              let row = this.oldList2.filter((e) => el.id === e.id)[0] || {};
              el.nutritionValue = row.nutritionValue;
              el.edit = false;
            });
        } else {
          let checkSave = this.list.filter((e) => e.edit);
          let data = {
            id: record.id,
            nutritionValue: record.nutritionValue,
          };
          if (checkSave.length > 1) {
            this.$confirm({
              title: "提示",
              content:
                "您还有其他的数据修改了未保存，您确认只保存当前行数据吗？",
              cancelText: "取消",
              okText: "确定",
              onOk: () => {
                this.$http
                  .post("/nhf-app/factorystaffnutritionraw/update", data)
                  .then((res) => {
                    let { success } = res;
                    if (success) {
                      this.calculationFlag = true;
                      // record
                      this.$message.success("修改成功");
                    } else {
                      this.$message.error("修改失败");
                    }
                    this.getList(this.pagination);
                  });
              },
              onCancel() {
                record.edit = true;
              },
            });
          } else {
            this.$http
              .post("/nhf-app/factorystaffnutritionraw/update", data)
              .then(() => {
                // let {success} = res;
                // if(success){
                //   this.calculationFlag = true
                //   this.$message.success('修改成功')
                // }else{
                //   this.$message.error('修改失败')
                // }
                this.getList(this.pagination);
              });
          }
        }
      } else {
        let newRecord = this.list.filter((el) => el.edit)[0] || {};
        if (this.recordObj.code === record.code) return;
        if (newRecord.code) {
          this.saveList(record, "row");
        } else {
          this.list &&
            this.list.map((el) => {
              el.edit = false;
            });
          record.edit = true;
          this.recordObj = record;
          setTimeout(() => {
            this.$refs.getFocus && this.$refs.getFocus.focus();
          }, 0);
        }
      }
    },
    deleteData() {
      if (this.selectList.length) {
        this.$confirm({
          title: "提示",
          content: "确认将选中的原料删除吗？",
          cancelText: "取消",
          okText: "确定",
          onOk: () => {
            let idArr = [];
            this.selectList.forEach((el) => {
              idArr.push(this.list[el].id);
            });
            let ids = idArr.join(",");
            this.$http
              .post(`/nhf-app/factorystaffnutritionraw/remove?ids=${ids}`)
              .then((res) => {
                let { success } = res;
                if (success) {
                  this.$message.success("删除成功");
                  this.getList();
                } else {
                  this.$message.error("删除失败");
                }
              });
          },
        });
      } else {
        this.$message.warning("请选中要删除的数据");
      }
    },
    resetData() {
      if (this.selectList && this.selectList.length > 0) {
        let ids = [];
        this.selectRows &&
          this.selectRows.forEach((el) => {
            ids.push(el.id);
          });
        let data = {
          ids: ids.toString(),
        };
        let DM = this.selectRows.filter((el) => el.name === "DM")[0] || {};
        let Moisture =
          this.selectRows.filter((el) => el.name === "Moisture")[0] || {};
        if (DM.name) {
          let obj = this.oldList.filter((v) => v.name === "Moisture")[0] || {};
          data.ids += "," + obj.id;
        }
        if (Moisture.name) {
          let obj = this.oldList.filter((v) => v.name === "DM")[0] || {};
          data.ids += "," + obj.id;
        }
        this.$http
          .post(
            "/nhf-app/factorystaffnutritionraw/resetFactoryStaffNutritionIds",
            data
          )
          .then((res) => {
            let { success } = res;
            if (success) {
              this.$message.success("重置成功");
              this.getList(
                { pageSize: this.pagination.pageSize, current: 1 },
                "refresh"
              );
            } else {
              this.$message.error("重置失败");
            }
          });
      } else {
        this.$message.warning("请选中要重置的数据");
      }
    },
    resetRecord(text, record) {
      // 查看价格
      this.$confirm({
        title: "提示",
        content: "确认重置当前养分吗？",
        cancelText: "取消",
        okText: "确定",
        onOk: () => {
          let data = {
            ids: record.id,
          };
          if (record.name === "DM") {
            let obj =
              this.oldList.filter((v) => v.name === "Moisture")[0] || {};
            data.ids += "," + obj.id;
          } else if (record.name === "Moisture") {
            let obj = this.oldList.filter((v) => v.name === "DM")[0] || {};
            data.ids += "," + obj.id;
          }
          this.$http
            .post(
              "/nhf-app/factorystaffnutritionraw/resetFactoryStaffNutritionIds",
              data
            )
            .then((res) => {
              let { success } = res;
              if (success) {
                this.$message.success("重置成功");
                this.getList(
                  { pageSize: this.pagination.pageSize, current: 1 },
                  "refresh"
                );
              } else {
                this.$message.error("重置失败");
              }
            });
        },
      });
    },
    addSubmit() {
      // 新增提交
      let ids = this.$refs["add"].selectList;
      let rawId = getRequest("id");
      if (!ids || ids.length === 0) {
        this.$message.warning("请选择需要添加的营养指标");
        return;
      }
      if (!rawId) {
        this.$message.warning("请选择需要添加的营养指标");
        return;
      }
      let factoryId = window.localStorage.getItem("factoryId");
      let data = {
        ids: ids.join(","),
        factoryId,
        rawId,
      };
      this.$http
        .post(
          "/nhf-app/factorystaffnutritionraw/batchSaveRawNutritionIds",
          data
        )
        .then((res) => {
          let { success } = res;
          if (success) {
            this.$message.success("新增成功");
          } else {
            this.$message.error("新增失败");
          }
          this.getList();
          this.showAddFunc();
        });
    },
    showAddFunc() {
      // 新增显示或关闭
      this.showAdd = !this.showAdd;
    },
    editSubmit() {
      // 编辑提交
      this.$refs["edit"].form.validateFields((err, values) => {
        console.log(values);
      });
      this.showEditFunc();
    },
    showEditFunc(type) {
      // 编辑显示或关闭
      if (type === "edtiBtn") {
        if (this.selectList.length > 1) {
          this.$message.warning("编辑只能选中一条数据");
        } else if (this.selectList.length === 0) {
          this.$message.warning("请选中需要编辑的数据");
        } else {
          this.showEdit = !this.showEdit;
        }
      } else {
        this.showEdit = !this.showEdit;
      }
    },

    // 一键清理
    clearAll() {
      this.$confirm({
        title: "恢复基础工厂数据",
        content: (
          <div style="color:red">
            清理后所有指标的【数值】将被清空，默认引用基础工厂的数值,
            <span style="color:#888">你还要继续吗？</span>
          </div>
        ),
        cancelText: "取消",
        okText: "确定",
        onOk: () => {
          this.getClearList();
        },
      });
    },

    // 获取一键清理数据
    async getClearList() {
      let res = await this.$http.post(
        "/nhf-custom/custfactorystaffnutritionraw/batchClearStaffCustNutritionRawList",
        {
          rawId: getRequest("rawId"),
          factoryId: window.localStorage.getItem("factoryId"),
          customId: getRequest('customId')
        }
      );
      let { success, data } = res;
      if (success) {
        if (data && Object.keys(data).length === 0) {
          this.list.forEach((item) => (item.nutritionValue = ""));

          // this.getList()
        }
        this.getList()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.listContent {
  height: 100%;
}
.spinning-block {
  .ant-spin-container {
    // display: flex;
    align-items: center;
    justify-content: center;
  }
}
.setBtn {
  border: 1px solid red;
  background-color: #fff;
  color: red;
  padding: 3px 14px;
  font-size: 13px;
  border-radius: 4px;
}
</style>
<style lang="scss">
.textLeft2{
  .editable-cell-text-wrapper{
    justify-content: start;
  }
  .editable-cell{
    display: block;
  }
}
</style>